// ** React Imports
import { useState } from 'react';
import CustomTable from '@myComponents/CustomTable';
import { LIST_ACTIVITIES } from '../../../../graphql/Query/roads';
import { deleteActivity, DuplicateActivity} from '../../../../graphql/Mutation/roads';
import { useMutation, useQuery } from '@apollo/client';
import { columns } from './columns';
import { handleConfirmCancel, handleError, handleConfirmDuplicate } from '@components/toast';
import { useNavigate } from 'react-router-dom';
import UploadDataCenterMasiveForm from '@components/MasiveUpload/MasiveUpload';
import Sidebar from '@components/sidebar';

const variables = {
  search: {
    type: '',
    status: 'EMPTY',
    q: '',
    perPage: 10,
    page: 1
  }
};

const ActivitiesList = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data, refetch, loading } = useQuery(LIST_ACTIVITIES, {
    variables
  });
  const navigate = useNavigate();
  const [handleDisable] = useMutation(deleteActivity);
  const [handleDuplicateActivity] = useMutation(DuplicateActivity);

  const toggleSidebar = () => {
    navigate('/roads/activities/new');
  };

  const handleDelete = async ({ e, row }) => {
    e.preventDefault();
    handleConfirmCancel('delete', false, async () => {
      try {
        await handleDisable({
          variables: { id: row._id },
          refetchQueries: 'all'
        });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const duplicateActivity = async (data) => {
    handleConfirmDuplicate(true, async () => {
      try {
        await handleDuplicateActivity({ variables: { activityId : data._id } });
        refetch();
      } catch (e) {
        console.log(e);
        
        handleError(e);
        throw e;
      }
    });
  };

  return (
    <><CustomTable
      loading={loading}
      store={data?.listActivities?.docs || []}
      data={{ ...data?.listActivities, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Actividad',
        handle: () => {
          toggleSidebar();
        }
      }}
      headerOptionsModal={{
        type: 'add',
        name: 'Carga Masiva',
        handle: () => {
          setSidebarOpen(true);
        }
      }}
      filterOptions={{
        types: [
          {
            id: 'activity_type',
            name: 'type',
            options: 'typeOptions',
            type: 'select'
          },
          {
            id: 'activity_status',
            name: 'status',
            options: 'statusOptions',
            type: 'select'
          }
        ]
      }}
      variables={variables}
      columns={columns({ handleDelete, navigate, duplicateActivity })}
    />
    
    <Sidebar
      size="lg"
      open={sidebarOpen}
      title={'' }
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={() => { setSidebarOpen(!sidebarOpen); }}
      onClosed={() => {}}
    >
      {sidebarOpen && <UploadDataCenterMasiveForm open={sidebarOpen} type="Actividades" toggleSidebar={() => { setSidebarOpen(!sidebarOpen); }} refetch={() => {}} />}
    </Sidebar>
    </>
  );
};

export default ActivitiesList;
